const constants = {
  UNLOADED: 'UNLOADED',
  FAILED: 'FAILED',
  FAILED_FATAL: 'FAILED_FATAL',
  FAILED_NOT_FOUND: 'FAILED_NOT_FOUND',
  LOADED: 'LOADED',
  STATE_CREATING: 'CREATING',
  STATE_SUCCESS: 'SUCCESS',
  STATE_FAIL: 'FAIL',
  ERROR_FORMAT: 'ERROR_FORMAT',
  ERROR_VALIDATION: 'ERROR_VALIDATION',
  ERROR_REQUIRED: 'ERROR_REQUIRED',
  ROLE_ACCOUNT_READ: 'accountDetails.read',
  ROLE_CUSTOMER_READ: 'customerDetails.read',
  ROLE_CUSTOMER_WRITE: 'customerDetails.write',
  ROLE_REQUEST_READ: 'workRequests.read',
  ROLE_REQUEST_WRITE: 'workRequests.write',
  ROLE_BANK_READ: 'bankAccount.read',
  ROLE_BANK_WRITE: 'bankAccount.write',
  ROLE_APPOINTMENTS_READ: 'appointments.read',
  // Arrangement write role does not exist yet so using customer write for now.
  ROLE_ARRANGEMENT_WRITE: 'customerDetails.write',
  DAILY_REQUEST_LIMIT: 10,
  BANK_UPDATE_LIMIT: 3,
  JOBS_PER_REQUEST_LIMIT: 5,
  HEADER_HEIGHT_DESKTOP: 120,
  HEADER_HEIGHT_MOBILE: 70,
  NAME_MIN_LENGTH: 2,
  TEXT_SEPERATOR: ' | ',
  PHONE_REGEX: /^0[0-9]{8,}$/,
  EMAIL_REGEX:
    /^(?:[a-z0-9!#$%&'*+/=?^_`{|}~-]+(?:\.[a-z0-9!#$%&'*+/=?^_`{|}~-]+)*)@(?:(?:[a-z0-9](?:[a-z0-9-]*[a-z0-9-])?\.)+[a-z0-9](?:[a-z0-9-]*[a-z0-9]))$/i,
};

export default constants;
